import React, { useEffect, useState, useRef } from 'react';
import Grid from '@mui/material/Grid';
import DOMPurify from 'dompurify';
import TextField from '@mui/material/TextField';
import ButtomCustom from '../../ButtonRound';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import CommentIcon from '@mui/icons-material/Comment';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import NumericInput from 'react-numeric-input';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import TestTitle from '../TestTitle';
import parse from 'html-react-parser';
import { getPathCourseResource } from '../../../utils/electronFunctions';
import HttpClient from '../../../helpers/HttpClient'; 
import AlertModal from '../components/AlertModal';
import { ToastContainer } from 'react-toastify';
import OverlayLoader from '../../OverlayLoader';
import { showToast } from '../../../utils/toast';
import RadarChart from '../../RadarChart';
import { getMysqlDate } from '../../../utils/generals';
import '../styles.scss';

const InputNumberTest = ({ data, courseCode, onFinalize, onContinue }) => {
  const answers = useRef(
    Array(0).fill({
      category: '',
      value: 0,
    })
  );
  const [questions, setQuestions] = useState(Array(0).fill('Pregunta'));
  const [openModalWelcome, setOpenModalWelcome] = useState(true);
  const [openModalEnd, setOpenModalEnd] = useState(false);
  const [categories, setCategories] = useState([]);
  const [currentTest, setTest] = useState(null);
  const [open, setOpen] = useState(false);
  const [isOpenRadarModal, setIsOpenRadarModal] = useState(false);
  const [testSaved, setTestSaved] = useState(false);
  const authState = useSelector((state) => state.auth);
  const [modalInitData, setModalInitData] = useState({
    title: '',
    content: '',
    buttonText: '',
  });

  const [modalEndData, setModalEndData] = useState({
    title: '',
    content: '',
    buttonText: '',
  });

  const [serieRadarChart, setSerieRadarChart] = useState([
    {
      name: 'Área',
      data: [],
    },
  ]);

  const [listEndModalSituacional, setListEndModalSituacional] = useState([]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log((event.target as HTMLInputElement).value);
  };

  const handleAnswerChange = (valueAsNumber, valueAsString, input) => {
    const nameParts = input.name.split('-');
    if (
      (valueAsNumber < currentTest.rango_inicial &&
        questions[parseInt(nameParts[2])].permite_cero == 0) ||
      valueAsNumber > currentTest.rango_final
    ) {
      showToast('Valor no válido');
    } else {
      const newAnswers = [...answers.current];
      newAnswers[parseInt(nameParts[2])] = {
        category: nameParts[0],
        value: valueAsNumber,
      };
      answers.current = newAnswers;
      console.log(answers.current);
    }
  };

  const SituationalResponse = () => {
    const preventDefault = (event: React.SyntheticEvent) =>
      event.preventDefault();

    return (
      <>
        <List
          sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
        >
          {listEndModalSituacional.map((value, index) => (
            <ListItem
              key={index}
              disableGutters
              secondaryAction={
                <Badge
                  badgeContent={`${value.average}`}
                  color="primary"
                ></Badge>
              }
            >
              <ListItemText primary={`${value.category}`} />
            </ListItem>
          ))}
        </List>
        <Box
          sx={{
            typography: 'body1',
            '& > :not(style) ~ :not(style)': {
              ml: 2,
            },
            textAlign: 'center',
          }}
          onClick={preventDefault}
        >
          <Link onClick={setIsOpenRadarModal} href="#">
            Ver Mapa
          </Link>
        </Box>
      </>
    );
  };

  const resultForSituacional = (resultForSituacional = true) => {
    const arForList = [];
    console.log(answers.current);
    for (let i = 0; i < categories.length; i++) {
      let arValues = [];
      for (let j = 0; j < answers.current.length; j++) {
        if (answers.current[j].category == categories[i]) {
          if (answers.current[j].value == 0) {
            if (questions[j].permite_cero == 0) {
              arValues.push(answers.current[j].value);
            }
          } else {
            arValues.push(answers.current[j].value);
          }
        }
      }
      let average =
        arValues.length > 0
          ? arValues.reduce((accumulator, currentValue) => {
              return accumulator + currentValue;
            }, 0) / arValues.length
          : 0;
      average =
        Number(average) % 1 == 0 ? Number(average) : Number(average).toFixed(1);

      arForList.push({
        category: categories[i],
        average: average,
      });
    }

    console.log(arForList);

    setListEndModalSituacional(arForList);

    setSerieRadarChart([
      {
        name: 'Valor',
        data: arForList.map((ele) => Number(ele.average)),
      },
    ]);
    if (resultForSituacional){

      setModalEndData({
        title: 'ANÁLISIS SITUACIONAL',
        content: SituationalResponse(),
        buttonText: 'Aceptar',
      });

      setOpenModalEnd(true);
    }

  };

  const saveResult = async() => {
    setOpen(true);
    let canSaving = true;

    for (let i = 0; i < questions.length; i++) {
      if (answers.current[i].value == 0 && questions[i].permite_cero == 0) {
        canSaving = false;
      }

      if (answers.current[i].value != 0 && questions[i].permite_cero == 0) {
        if (
          answers.current[i].value < currentTest.rango_inicial ||
          answers.current[i].value > currentTest.rango_final
        ) {
          canSaving = false;
        }
      }
    }

    if (canSaving) {

      const userId =
        authState && authState.user ? authState.user.email : 'test';
      const currentDate = getMysqlDate();
      const arrayValues = [];

      for (let i = 0; i < answers.current.length; i++) {
        arrayValues.push({
          userId: userId,
          cod_test: currentTest.cod_test,
          questionId: questions[i].id,
          answerValue: answers.current[i].value,
          currentDate: currentDate,
        });
      }

      const originId = data.id ? data.id : data.cod_leccion;
      const originType = data.id ? "SUBLESSON" : "LESSON";

      const request = await HttpClient().post(`/tests/input/save/${userId}/${originId}/${currentTest.cod_test}/${originType}`, arrayValues)
      
      onFinalize(true);
      switch (currentTest.cod_test) {
        case 'COVI_AnalisisSituac':
          resultForSituacional();
          setTestSaved(true);
          break;
      }
    } else {
      showToast('Debes completar todos los datos con valores válidos');
    }

    setOpen(false);
  };

  const imagePaths = async (html, stringImages, path) => {
    const images = stringImages ? stringImages.split(',') : null;
    let content = html;
    if (Array.isArray(images)) {
      for (let i = 0; i < images.length; i++) {
        let finalPath = '';
        if (images[i].indexOf('commons/') != -1) {
          finalPath = await getPathCourseResource(
            images[i].replace('commons', 'commons')
          );
        } else {
          finalPath = await getPathCourseResource(
            path + '/img/' + images[i]
          );
        }
        content = content.replace(images[i], finalPath);
      }
    }
    return content;
  };

  const loadTestData = async () => {

    const userId = authState && authState.user ? authState.user.email : 'test';

    const request = await HttpClient().get(`/tests/input/${userId}/${data.test_id}`)

    if (request.error) {
      showToast("No se pudo cargar información del test. Refresca la página e intenta nuevamente.", "error");
      return;
    }

    const test = request.data.test;
    console.log(test);
    if (test) {
      const testData = test;
      setTest(testData);
      if (testData.encabezado && testData.encabezado != '') {
        let htmlContent = testData.encabezado;
        const path = courseCode;
        if (testData.img_encabezado && testData.img_encabezado != '') {
          htmlContent = await imagePaths(
            htmlContent,
            testData.img_encabezado,
            path
          );
        }
        setModalInitData({
          title: '',
          content: htmlContent,
          buttonText:
            testData.texto_boton && testData.texto_boton != ''
              ? testData.texto_boton
              : 'Aceptar',
        });
      } else {
        setModalInitData({
          title: '',
          content: '',
          buttonText: '',
        });
      }
    } else {
      setModalInitData({
        title: '',
        content: '',
        buttonText: '',
      });
    }

    const questions = request.data.questions;

    const answersTest = request.data.answers

    console.log(questions);
    if (questions) {
      const categoryArray = [
        ...new Set(
          questions.map((ele, index) => {
            return ele.nombre;
          })
        ),
      ];
      setCategories(categoryArray);
      console.log(categoryArray);
      setQuestions(questions);

      if (answersTest && answersTest.length > 0) {
        const answersTemp = [];
        for (let i = 0; i < questions.length; i++) {
          const r = answersTest.filter(
            (ele) => ele.id_pregunta == questions[i].id
          )[0];
          answersTemp.push({
            category: questions[i].nombre,
            value: r.valor,
          });
        }
        answers.current = answersTemp;
      } else {
        answers.current = new Array(questions.length).fill({
          category: '',
          value: 0,
        });
      }
    } else {
      setCategories([]);
      setQuestions([]);
      answers.current = [];
    }
  };

  useEffect(() => {
    if (data) {
      setOpen(true);
      loadTestData();
      document.getElementsByClassName("main")[0].scrollTo({ top: 0, left: 0 });
      setOpen(false);
    }
  }, [data]);

  return (
    <Grid container columns={{ xs: 4, md: 12 }} spacing={2} key={data.test_id}>
      <OverlayLoader open={open} />
      {currentTest ? (
        <>
          <Grid item xs={12}>
            {data ? (
              <TestTitle
                title={data.nombre}
                component={'div'}
                color={'white'}
              />
            ) : null}
          </Grid>
          <Grid item xs={12}>
            <div className="tests-container">
              {categories && categories.length > 0 ? (
                <>
                  {categories.map((ele1, index) => (
                    <Box className="container-area">
                      <TestTitle
                        title={ele1}
                        component={'nav'}
                        color={'white'}
                        barColor={'secondary'}
                        key={ele1}
                      />

                      <Box component="main" sx={{ p: 3 }} key={Math.random()}>
                        {questions.map((ele, index2) => (
                          <>
                            {ele.nombre == ele1 ? (
                              <div className="question-container" key={index2}>
                                <div className="question input-number-cuestion">
                                  {parse(ele.pregunta)}
                                </div>
                                <div
                                  className="input-number-container"
                                  key={index2}
                                >
                                  <NumericInput
                                    key={index2}
                                    strict={false}
                                    value={
                                      answers.current[index2] && answers.current[index2].value > 0
                                        ? answers.current[index2].value 
                                        : ""
                                    }
                                    name={ele1 + '-input-' + index2}
                                    min={
                                      ele.permite_cero == 1
                                        ? 0
                                        : currentTest.rango_inicial
                                    }
                                    max={currentTest.rango_final}
                                    step={1}
                                    size={6}
                                    format={(num) => {
                                      if (num < currentTest.rango_inicial) {
                                        return ele.permite_cero == 1
                                          ? 0
                                          : currentTest.rango_inicial;
                                      }
                                      if (num > currentTest.rango_final) {
                                        return currentTest.rango_final;
                                      }
                                      return num;
                                    }}
                                    onChange={handleAnswerChange}
                                    style={{
                                      wrap: {
                                        background: 'white',
                                        boxShadow:
                                          '0 0 1px 1px #fff inset, 1px 1px 5px -1px #000',
                                        padding: '2px 2.26ex 2px 2px',
                                        borderRadius: '6px 3px 3px 6px',
                                        fontSize: 18,
                                      },
                                      input: {
                                        borderRadius: '4px 2px 2px 4px',
                                        padding: '0.1ex 1ex',
                                        border: '1px solid #white',
                                        marginRight: 4,
                                        display: 'block',
                                        fontWeight: 100,
                                        textShadow:
                                          '1px 1px 1px rgba(0, 0, 0, 0.1)',
                                      },
                                      'input:focus': {
                                        border: '1px inset #white',
                                        outline: 'none',
                                      },
                                    }}
                                  />
                                </div>
                              </div>
                            ) : null}
                          </>
                        ))}
                      </Box>
                    </Box>
                  ))}
                </>
              ) : null}
            </div>
          </Grid>
          <Grid item xs={12} className="lessons-button-container-center">
            {!testSaved ? (
              <ButtomCustom
                variant="contained"
                onClick={() => {
                  saveResult();
                }}
                rounded
              >
                Guardar
              </ButtomCustom>
            ) : (
              <ButtomCustom
                variant="contained"
                onClick={() => {
                  onContinue();
                }}
                rounded
              >
                Continuar
              </ButtomCustom>
            )}
          </Grid>
        </>
      ) : null}

      <AlertModal
        open={openModalWelcome}
        title={''}
        content={parse(modalInitData.content)}
        buttonText={modalInitData.buttonText}
        onButtonClick={() => {
          setOpenModalWelcome(false);
        }}
      />
      <AlertModal
        open={openModalEnd}
        title={modalEndData.title}
        content={SituationalResponse()}
        buttonText={modalEndData.buttonText}
        onButtonClick={() => {
          setOpenModalEnd(false);
        }}
      />

      <AlertModal
        open={isOpenRadarModal}
        title={''}
        content={
          <RadarChart
            title={'Mapa situacional'}
            series={serieRadarChart}
            categories={categories}
          />
        }
        buttonText={'Cerrar'}
        onButtonClick={() => {
          setIsOpenRadarModal(false);
        }}
        maxWidth={'lg'}
      />
      {/*<ToastContainer />*/}
    </Grid>
  );
};

export default InputNumberTest;
